import {
    deDE as originalDeDELocale,
    enUS as originalEnUSLocale,
} from "@mui/x-data-grid/locales";

const common = { toolbarColumns: "", toolbarFilters: "" };

export const deDE = {
    ...originalDeDELocale.components.MuiDataGrid.defaultProps
        .localeText,
    ...common,
    filterOperatorIsNot: "ist nicht",
};

export const enUS = {
    ...originalEnUSLocale.components.MuiDataGrid.defaultProps
        .localeText,
    ...common,
    filterOperatorIsNot: "is not",
};
